import type { CountryKey, LocaleCode, Testimonial } from "~/types";

type PageToTestimonials = Partial<Record<CountryKey | 'home', Testimonial[]>>;

export default {
  en: {},
  sv: {},
  he: {},
  ru: {
    home: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A",
        stacked: true
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9",
        stacked: true
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9",
        stacked: true
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79",
        stacked: true
      }
    ],
    india: [
      {
        name: "Виктор Б.",
        body: "Огромная благодарность компании за помощь в оформлении срочной визы в Индию. Купили билеты и за сутки поняли, что у нас нет визы))) обратились в Визанет в 16 часов в пятницу, а вылет в субботу вечером , на следующей день в 17 часов нам прислали визы!! Ещё раз большое спасибо! Удобный сайт, экспертное общение и качественное оказание услуги!",
        date: "18 января 2025",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Юлия",
        body: "Визу в Индию получила буквально за несколько дней, цена оправдана",
        date: "23 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/MP6kB6DfodkXQ5Ys9",
        stacked: true
      },
      {
        name: "Михаил С.",
        body: "Спасибо за помощь с визой в Индию. Очень оперативно и профессионально все оформили.",
        date: "11 февраля 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Ольга Р.",
        body: "Добрый вечер! Отличное и качественное обслуживание, а главное- цены приемлемые. 5 летнюю визу в Индию оформили без проблем. Ранее я сама оформляла визу, но сейчас проблемы с оплатой. На сервисе все сделали быстро и качественно. Спасибо.",
        date: "18 октября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Юлия А.",
        body: "Получали тут визы в Индию. Все анкеты заполняли на сайте без посещения офиса. Визы получили даже без бронирования отеля.",
        date: "3 февраля 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/aKeuZpJ2cPY2eXpR7",
        stacked: true
      },
      {
        name: "Роман Г.",
        body: "Заказывал тут визу в Индию. Сделали всё чётко и быстро за несколько дней. Сервис рекомендую!",
        date: "11 января 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/o7eKcT52j2jQkQMR6",
        stacked: true
      },
      {
        name: "Дарья З.",
        body: "Индия наконец-то открылась после длительного перерыва. Сделала тут туристическую онлайн визу. Выдали за два дня. Рекомендую!",
        date: "19 октября 2021",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336",
        stacked: true
      }
    ],
    indonesia: [
      {
        name: "Sam P.",
        body: "В Индонезию визу сделали за 3 дня, быстро оформляют и отвечают на все вопросы 24/7. Доволен.",
        date: "6 октября 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/cTAXwbWewE7ojtq4A",
        stacked: true
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9",
        stacked: true
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9",
        stacked: true
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79",
        stacked: true
      }
    ],
    israel: [
      {
        name: "Дмитрий Х.",
        body: "Отличный и быстрый сервис. Поддержка работает хорошо, отвечали быстро и сделали разрешение в Израиль за три дня.",
        date: "07 февраля 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/MmuUu27TqxZqArf48",
        stacked: true
      },
      {
        name: "Варвара Б.",
        body: "Обращалась сюда за ЕТА в Израиль т.к с января это стало обязательно, сделали за один день",
        date: "25 декабря 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Борис С.",
        body: "Самые лучшие впечатления. Впервые воспользовался услугами компании, надо было оформить ETA-IL для поездки в Израиль. Оформили в течение нескольких часов. Огромное спасибо! Всем рекомендую.",
        date: "9 января 2025",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Людмила",
        body: "Супер быстрое оформление, ЕТА в Израиль за один выходной день! Огромное спасибо!",
        date: "05 февраля 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/SfwSGv9iwH4KsLJa8",
        stacked: true
      },
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A",
        stacked: true
      },
      {
        name: "Эльмира",
        body: "Оформляла визу в Израиль через компанию «Визанет.ру». Прошло все максимально легко и быстро за очень адекватные деньги. На всех этапах оформления на связи менеджер, который отвечает на все вопросы. Очень хороший сервис. Мне все понравилось.",
        date: "18 июня 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9",
        stacked: true
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9",
        stacked: true
      }
    ],
    korea: [
      {
        name: "Лоськова Т.",
        body: "Огромное спасибо компании за оформление K-ETA. Всё быстро, чётко, понятно, профессионально. Все документы заполняла на сайте. В чате оперативно отвечали на вопросы даже в выходные. Спасибо! Буду рекомендовать друзьям.",
        date: "12 февраля 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/hRJax3fyLhUdDDRP7"
      },
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A",
        stacked: true
      },
      {
        name: "Михаил А.",
        body: "Очень выручили меня со срочной визой в Корею. Спасибо!",
        date: "27 декабря 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Людмила Ш.",
        body: "Оформляла визу в Южную Корею в этом сервисе. Виза электронная, оформляется онлайн просто и быстро и без посещения офиса и консульства. Также понравилась круглосуточная поддержка менеджеров. Рекомендую",
        date: "18 июня 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Татьяна Г.",
        body: "Максимально простая анкета, справилась быстро. Визу в Корею сделали за 2 дня 👍🏼",
        date: "8 декабря 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336",
        stacked: true
      },
      {
        name: "Лариса Л.",
        body: "Отличный сервис. Сделали срочно визу в Корею за один день!",
        date: "26 февраля 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/Y2TyNuT78BWJZS9c6",
        stacked: true
      },
      {
        name: "Валентина Т.",
        body: "Оперативно сделали визу В Корею",
        date: "23 января 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Юлия П.",
        body: "Через официальный сайт не получилось оформить визу в Южную Корею. Заказала тут, платила рос картой. Всё норм",
        date: "11 февраля 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336",
        stacked: true
      }
    ],
    saudi_arabia: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A",
        stacked: true
      },
      {
        name: "Ермак К.",
        body: "Заказывал в Саудовскую Аравию, сначала боялся что дешево, но в итоге дали без проблем",
        date: "31 декабря 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9",
        stacked: true
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9",
        stacked: true
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79",
        stacked: true
      }
    ],
    vietnam: [
      {
        name: "Вик",
        body: "Делали евизу 90 дней Вьетнам. Во первых наши карты Рф не принимают. А у посредников нет гарантии оплаты. Сервис виза нет не только оплатит но и заполнит и подаст за вас все документы. Всем советую. Переплата 2000 р экономит нервы и время на перевод документов. СПАСИБО.",
        date: "14 февраля 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/P1W9kPy4LLcU1zxP8"
      },
      {
        name: "Демид Ш.",
        body: "Получил тут e-visa во Вьетнам все было быстро и понятно. Большое спасибо.",
        date: "13 февраля 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A",
        stacked: true
      },
      {
        name: "Виктория Д.",
        body: "Не первый раз использую услуги Визанет, в этот раз нужна была виза во Вьетнам. Как всегда быстро и без проблем. Оплата картой прошла без трудностей и через два дня виза уже была у меня. Теперь не терпится отправится в путешествие! Большое спасибо за отличный сервис!",
        date: "16 июня 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9",
        stacked: true
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79",
        stacked: true
      }
    ],
    bahrain: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A",
        stacked: true
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9",
        stacked: true
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9",
        stacked: true
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79",
        stacked: true
      }
    ],
    togo: [
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A",
        stacked: true
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9",
        stacked: true
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9",
        stacked: true
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79",
        stacked: true
      }
    ],
    thailand: [
      {
        name: "Ева А.",
        body: "Оформила онлайн новую DTV визу в Тайланд на 5 лет, визанет помогли мне собрать недостающее документы и правильно сделать анкету, в общем всё под ключ. Огромная благодарность!",
        date: "17 мая 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/dGSkEyQ14REkKRGi9",
        stacked: true
      },
      {
        name: "Nadezhda A.",
        body: "Отличная фирма, вежливо, четко, быстро! Всем рекомендую!",
        date: "14 января 2025",
        img: "google.png",
        url: "https://maps.app.goo.gl/1fohsBpUoB8FugX7A",
        stacked: true
      },
      {
        name: "Vitaliy B.",
        body: "Очень удобный и понятный сервис. Обратился в визанет после неудачного обращения в другую службу. Положительный контраст: заказ визы сопровождается констатацией промежуточных этапов, что важно для понимания процесса заказа. Виза оформлена очень быстро",
        date: "29 сентября 2024",
        img: "yandex.png",
        url: "https://yandex.ru/profile/204631911336"
      },
      {
        name: "Мария О.",
        body: "Сопровождали меня на каждом этапе, очень понравилось отношение.",
        date: "28 мая 2024",
        img: "2gis.png",
        url: "https://2gis.ru/moscow/firm/70000001082433864",
        stacked: true
      },
      {
        name: "Гульнара З.",
        body: "Понравился визовый центр тем, что никуда ездить не нужно, быстрое оформление, всё чётко профессионально.",
        date: "4 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/ZDaNuFEESu1tppPE9",
        stacked: true
      },
      {
        name: "Anton S.",
        body: "Прекрасный сервис где все можно сделать дистанционно! Вежливые менеджеры отзывчивы и нацелены на результат, проявляют заинтересованность.",
        date: "29 июня 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/HKbV2MxPrAQ8znNf9",
        stacked: true
      },
      {
        name: "Соня Б.",
        body: "Отвечали на мои вопросы даже в выходной день) Ответственно подходят к делу",
        date: "5 мая 2024",
        img: "google.png",
        url: "https://maps.app.goo.gl/4XqEyMB4uvmZ2iw79",
        stacked: true
      }
    ]
  },
  'ru-KZ': {}
} satisfies Record<LocaleCode, PageToTestimonials>;